// 换句话说，如果你是在html文件内，通过内联在元素上直接写或者link方式去加载的样式，都不会被第三方工具转化。
// //html文件
// <!--不会被转化-->
// <link href="css/your.css" rel="stylesheet" type="text/css" >
//   <!--不会被转化-->
//   <div style="width:15px"><div>
//   如果基于不管何种原因，非要在html文件内写样式，那就只能手动进行换算。以宽度750px的设计稿为例，即750px=100vw，换算结果为 7.5px=1vw。假如设计稿上测量到某一个区域宽度为15px，那么 15/7.5=2vw
//
// //html文件
// <!--手动换算-->
// <div style="width:2vw"><div>
const viewportUnitsBuggyfill = require('viewport-units-buggyfill');
const hacks = require('viewport-units-buggyfill/viewport-units-buggyfill.hacks');
viewportUnitsBuggyfill.init({
   force: false,  //忽略用户代理初始化
	 refreshDebounceWait:250,  //改变窗口大小时候的单位抖动
	//处理兼容性
 // * vmin in IE9
//   * vmax in IE9, iOS <= 6
//   * calc(vh/vmin) in iOS < 8 and Android Stock Browser <= 4.4
//   * all of viewport units in Android Stock Browser <= 4.3
 	hacks:hacks,
  appendToBody: true   //将修补的兼容性样式表附加到body下面而不是头上。
});

// you can do things manually (without the style-element injection): 您可以手动完成（没有样式元素注入）：
// identify all declarations using viewport units //使用视口单元标识所有声明
// viewportUnitsBuggyfill.findProperties();
// var cssText = viewportUnitsBuggyfill.getCss();
window.addEventListener('viewport-unit-buggyfill-init', function() {
	viewportUnitsBuggyfill.findProperties();
	var cssText = viewportUnitsBuggyfill.getCss();
  console.log('getting lost in CSSOM');
});
window.addEventListener('viewport-unit-buggyfill-style', function() {
  console.log('updated rules using viewport unit');
});



// WEBPACK FOOTER //
// ./src/viewport-units-buggyfill-init.js